import { Controller } from "@hotwired/stimulus";
import { handleClientSideError, initDropzone, resetDropzoneFiles } from "../../../components/dropzone";
import { alertJsonResponseError } from "../../../utils/http_utils";
import { hideSpinner } from "../../../sales_invoices/send_invoice_by_email";

const MAX_ATTACHMENTS_SIZE = 5000000;

export default class extends Controller {
  static targets = [
    "filePreviewsContainer",
    "dragAndDropContainer",
    "removeAttachmentTemplate",
    "errorMessage",
    "addAttachmentButton",
  ];

  connect() {
    this._initDropzone();
  }

  addAttachment(e) {
    e.stopPropagation();
    this.dropzone.hiddenFileInput.click();
  }

  _initDropzone() {
    this.dropzone = initDropzone(this.element.id, {}, this._uploadOptions());
    this._initCustomEvents();
  }

  _uploadOptions() {
    return {
      maxFiles: 12,
      paramName: "attachments",
      previewsContainer: this.filePreviewsContainerTarget,
      clickable: `#${this.dragAndDropContainerTarget.id}`,
      previewTemplate: this.removeAttachmentTemplateTarget.innerHTML,
      addRemoveLinks: false,
    };
  }

  _initCustomEvents() {
    this.dropzone.on("addedfile", (file) => {
      this._resetErrorMessage();
      this._handleMaxAttachmentsSizeExceeded(file);
      this._handleAttachmentRemoved(this.dropzone, file);
    });

    this.dropzone.on("maxfilesreached", () => {
      this._hideAddAttachmentButton();
    });

    this.dropzone.on("maxfilesexceeded", (file) => {
      this.dropzone.removeFile(file);
    });

    this.dropzone.on("error", (file, response, xhr) => {
      if (xhr) {
        resetDropzoneFiles(this.dropzone);
        alertJsonResponseError(xhr.response, xhr.status);
        hideSpinner();
      } else {
        this.dropzone.removeFile(file);
        handleClientSideError(this.dropzone, response);
      }
    });

    this.dropzone.on("success", (_file, response) => {
      this.element.dispatchEvent(
        new CustomEvent("emailAttachments:uploaded", { detail: [{ message: response.message }] })
      );
    });
  }

  _handleAttachmentRemoved(dropzone, file) {
    const removeAttachmentButton = file.previewElement.querySelector(".remove-attachment-button");
    removeAttachmentButton.addEventListener("click", (e) => {
      e.stopPropagation();
      dropzone.removeFile(file);
      this._showAddAttachmentButton();
      this._resetErrorMessage();
    });
  }

  _handleMaxAttachmentsSizeExceeded(file) {
    const attachmentsSize = this.dropzone.files.reduce((acc, file) => acc + file.size, 0);

    if (attachmentsSize > MAX_ATTACHMENTS_SIZE) {
      this.dropzone.removeFile(file);
      this.errorMessageTarget.innerText = "Le poids total des pièces jointes ne doit pas dépasser 5 Mo";
    }
  }

  _resetErrorMessage() {
    this.errorMessageTarget.innerText = "";
  }

  _showAddAttachmentButton() {
    this.addAttachmentButtonTarget.classList.remove("hidden");
  }

  _hideAddAttachmentButton() {
    this.addAttachmentButtonTarget.classList.add("hidden");
  }
}
